<div class="flex flex-col gap-y-1">
  <div class="flex pl-10 font-normal font-['Open_Sans'] text-xs text-[var(--colorDefault)] opacity-65 gap-[0.625rem]">
    <span>AI Service</span> {{ createdTime | date:'h:mm a' }}
  </div>

  <div class="flex items-start gap-2">
    <div class="ai-icon-spinner-wrapper">
      <div class="ai-icon-inner">
        <span>AI</span>
      </div>
    </div>

    <div class="flex flex-col gap-y-2">
      @let promptHtml = aboveWidgetHtml();
      @if (promptHtml) {
        <div
          class="chat-bot-message bg-[var(--botBubbleColor)] text-[var(--textBotBubbleColor)] font-normal font-['Open_Sans'] text-base"
        >
          <span
            class="typing-text message-container leading-relaxed whitespace-pre-line break-words"
            [innerHTML]="promptHtml"
          ></span>
        </div>
      }

      <ng-container [ngSwitch]="attachment?.type">
        <app-feedback-rating
          *ngSwitchCase="'FEEDBACK_RATING'"
          [payload]="attachment?.payload ?? null"
          [state]="attachment?.state ?? null"
          (ratingSelected)="onWidgetSubmit($event)"
        ></app-feedback-rating>

        <!--
          Add new widget cases here. Pattern:
            <app-quick-replies
              *ngSwitchCase="'QUICK_REPLIES'"
              [payload]="attachment?.payload ?? null"
              [state]="attachment?.state ?? null"
              (optionChosen)="onWidgetSubmit($event)">
            </app-quick-replies>
        -->
      </ng-container>
    </div>
  </div>
</div>
